module.exports = __webpack_public_path__ + "static/media/ic-imagem.df29f22a.svg";